import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import usePluginEntities from "hooks/usePluginEntities";
import Alert from "components/bootstrap/Alert";
import Button from "components/bootstrap/Button";
import AppConfig from "util/AppConfig";
import useDisclosure from "util/hooks/useDisclosure";
const FlexWrap = styled.div`
  display: flex;
  align-items: center;
`;
const ShortContent = styled.p`
  flex: 1;
  margin: 0;
  font-weight: bold;
`;
const LongContent = styled.div(
  ({ $visible }) => css`
    white-space: pre-wrap;
    display: ${$visible ? "block" : "none"};
    padding-top: 12px;
  `
);
const StyledAlert = styled(Alert)`
  margin-bottom: 6px;
  padding-right: 9px;
`;
const Wrapper = styled.div`
  width: 90%;
  margin: 0 auto 15px;
`;
const AlertContainer = styled.div(
  ({ theme }) => css`
    background-color: ${theme.colors.global.contentBackground};
  `
);
const defaultNotifications = {
  usePublicNotifications: () => ({
    notifications: void 0,
    dismissedNotifications: void 0,
    onDismissPublicNotification: void 0
  })
};
const PublicNotification = ({ notificationId, notification, onDismissPublicNotification }) => {
  const { t } = useTranslation("common");
  const [showReadMore, { toggle: toggleReadMore }] = useDisclosure(false);
  const { variant, hiddenTitle, isActive, isDismissible, title, shortMessage, longMessage } = notification;
  if (!isActive) {
    return null;
  }
  const _dismiss = () => onDismissPublicNotification(notificationId);
  return /* @__PURE__ */ React.createElement(AlertContainer, { key: title }, /* @__PURE__ */ React.createElement(
    StyledAlert,
    {
      bsStyle: variant != null ? variant : "default",
      onDismiss: isDismissible ? _dismiss : void 0,
      title: !hiddenTitle && title
    },
    /* @__PURE__ */ React.createElement(FlexWrap, null, /* @__PURE__ */ React.createElement(ShortContent, null, shortMessage), longMessage && /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", onClick: toggleReadMore }, showReadMore ? t("public_notifications.read_less") : t("public_notifications.read_more"))),
    longMessage && /* @__PURE__ */ React.createElement(LongContent, { $visible: showReadMore }, longMessage)
  ));
};
const PublicNotifications = ({ login = false }) => {
  var _a;
  const customizationHook = usePluginEntities("customization.publicNotifications");
  const { usePublicNotifications } = ((_a = customizationHook[0]) == null ? void 0 : _a.hooks) || defaultNotifications;
  const { notifications, dismissedNotifications, onDismissPublicNotification } = usePublicNotifications();
  const allNotification = useMemo(
    () => login ? AppConfig.publicNotifications() : notifications,
    [login, notifications]
  );
  const publicNotifications = useMemo(
    () => Object.keys(allNotification != null ? allNotification : {}).filter((notificationId) => !(dismissedNotifications == null ? void 0 : dismissedNotifications.has(notificationId))).filter((notificationId) => {
      const notification = allNotification[notificationId];
      return login ? notification.atLogin : notification.isGlobal;
    }).map((notificationId) => {
      const notification = allNotification[notificationId];
      return /* @__PURE__ */ React.createElement(
        PublicNotification,
        {
          key: notificationId,
          notification,
          notificationId,
          onDismissPublicNotification
        }
      );
    }),
    [allNotification, dismissedNotifications, login, onDismissPublicNotification]
  );
  return publicNotifications.length ? /* @__PURE__ */ React.createElement(Wrapper, null, publicNotifications) : null;
};
export default PublicNotifications;
